import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import EdiText from 'react-editext';
import { AddRoomsModal } from '../add-rooms-modal/add-rooms-modal.component';

export interface RoomsProps {
  data: {
    units: {
      unitId: string;
      shortName: string;
      isActive: boolean;
      roomNumber: string;
    }[];
  };

  eventHandlers: {
    submitHandler: (data: {
      unitId: string;
      shortName: string;
      isActive: boolean;
      roomNumber: string;
    }) => void;
    submitNewHandler: (data: {
      unitId: string;
      shortName: string;
      isActive: boolean;
      roomNumber: string;
    }) => void;
  };
}

export const Rooms: React.FC<RoomsProps> = ({ data, eventHandlers }) => {
  const [showAddroomModal, setShowAddroomModal] = useState<boolean>(false);
  return (
    <>
      <AddRoomsModal
        config={{ showModal: showAddroomModal }}
        data={{
          id:
            data.units && data.units.length
              ? data.units[0].unitId.split('-')[0] +
                '-' +
                (Math.max.apply(
                  null,
                  data.units.map((item) => Number(item.unitId.split('-')[1]))
                ) +
                  1)
              : ''
        }}
        eventHandlers={{
          cancelHandler: () => {
            setShowAddroomModal(false);
          },
          submitRoomHandler: (data) => {
            setShowAddroomModal(false);
            eventHandlers.submitNewHandler(data);
          }
        }}
      />

      <div className="mt-4 p-2 w-full">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold text-neutral-800">Rooms</h2>
          <button
            type="button"
            className="px-4 py-2 bg-primary-500 text-white text-base rounded-md flex items-center gap-2 hover:bg-primary-500/90 transition-colors"
            onClick={() => setShowAddroomModal(true)}
          >
            <AddIcon className="text-lg" />
            <span>Add</span>
          </button>
        </div>

        <div className="border border-neutral-200 rounded-lg overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-neutral-50 border-b border-neutral-200">
                <th className="text-left py-4 px-4 text-base font-medium text-neutral-500 uppercase tracking-wider">
                  ID
                </th>
                <th className="text-left py-4 px-4 text-base font-medium text-neutral-500 uppercase tracking-wider">
                  Room Name
                </th>
                <th className="text-left py-4 px-4 text-base font-medium text-neutral-500 uppercase tracking-wider">
                  Room #
                </th>
                <th className="text-left py-4 px-4 text-base font-medium text-neutral-500 uppercase tracking-wider">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {data.units.map((unit) => (
                <tr
                  key={unit.unitId}
                  className="border-b border-neutral-100 last:border-0 hover:bg-neutral-50 transition-colors"
                >
                  <td className="py-5 px-4 text-lg text-neutral-600 font-mono">{unit.unitId}</td>
                  <td className="py-5 px-4">
                    <EdiText
                      type="text"
                      value={unit.shortName}
                      className="text-lg text-neutral-800"
                      onSave={(val) => {
                        eventHandlers.submitHandler({ ...unit, shortName: val });
                      }}
                    />
                  </td>
                  <td className="py-5 px-4">
                    <EdiText
                      type="text"
                      value={unit.roomNumber}
                      className="text-lg text-neutral-800"
                      onSave={(val) => {
                        eventHandlers.submitHandler({ ...unit, roomNumber: val });
                      }}
                    />
                  </td>
                  <td className="py-5 px-4">
                    <span
                      className={`inline-flex items-center gap-1.5 text-base font-medium ${
                        unit.isActive ? 'text-emerald-600' : 'text-neutral-400'
                      }`}
                    >
                      <span
                        className={`w-1.5 h-1.5 rounded-full ${
                          unit.isActive ? 'bg-emerald-500' : 'bg-neutral-300'
                        }`}
                      />
                      {unit.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Rooms;
